/**
 * Check if element is within viewport.
 * @param {HTMLElement} element
 * @param {number} topMargin
 */
export const isInViewport = (element, topMargin = 0) => {
  const rect = element.getBoundingClientRect();
  return (
    rect.top >= 0 + topMargin &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
};
